import { BrowserRouter as Router, Routes, Route, useLocation, Outlet } from "react-router-dom";
import { ToastContainer } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
// import { checkToken, setToken } from "./tools/services";
// import { useAPIPublic } from "./tools/api";
import { useEffect } from "react";
import Header from "./components/header";
import { useTheme } from "./context/ThemeContext";
import Dashboard from "./components/dashboard/dashboard";
import { _adr } from "./address";
import Login from "./components/security/login/login";
import ForgetPassword from "./components/security/forgetpassword/forgetpass";
import TwoStepConfirm from "./components/security/twoStepConfirm";
import ChangePassword from "./components/security/changepassword/changePassword";
import { ProtectedRoute, ProtectedRouteLogin } from "./tools/protectedRoute";
import { Provider } from "react-redux";
import { persistor, store } from "./reducer/store";
import { PersistGate } from "redux-persist/integration/react";
import SPKit from "./components/simcardPurchase/shop/sp-kit/spkit";
import SPMsisdn from "./components/simcardPurchase/shop/msisdn/msisdn";
import SPProfile from "./components/simcardPurchase/shop/profile/profile";
import SpPreFactor from "./components/simcardPurchase/shop/prefactor/Prefactor";
import SPDocument from "./components/simcardPurchase/shop/document/doc-print";
import SPFinalFactor from "./components/simcardPurchase/shop/final/final";
import CSValidMsisdn from "./components/changeSimCard/change/valid";
import CSNewKit from "./components/changeSimCard/change/kit/newKit";
import CSPrefactor from "./components/changeSimCard/change/prefactor/csprefactor";
import CSDocument from "./components/changeSimCard/change/document/csDocument";
import CSFinalFactor from "./components/changeSimCard/change/final/csfinal";
import ViewProfile from "./components/acounts/profile/viewProfile";
import Changepassword from "./components/acounts/changepassword/changepassword";
import "./App.scss";
import AccountInfo from "./components/acounts/acountInfo/account-info/accountInfo";
import Accountlist from "./components/acounts/acountInfo/account-list/accountlist";

import { MainLayout } from "./components/layouts/layout.jsx";
import DCCharge from "./components/dcPurchase/shop/charge/dcCharge";
import DCPrefactor from "./components/dcPurchase/shop/prefactor/dcPrefactor";
import DCFinal from "./components/dcPurchase/shop/final/dcFinal";
import SPFKit from "./components/simcardPurchase/foreigners/spf-kit/spf-kit";
import SPFMsisdn from "./components/simcardPurchase/foreigners/spf-msisdn/spf-msisdn";
import SPFAuthentication from "./components/simcardPurchase/foreigners/spf-authentication/spf-authentication";
import SPFProfile from "./components/simcardPurchase/foreigners/spf-profile/spf-profile";
import SPFPrefactor from "./components/simcardPurchase/foreigners/spf-prefactor/spf-prefactor";
import SPFDocument from "./components/simcardPurchase/foreigners/spf-document/spf-document";
import SPFFinalFactor from "./components/simcardPurchase/foreigners/spf-final/spf-final";
import EPValid from "./components/epPurchase/shop/valid/epValid";
import EPPrefactor from "./components/epPurchase/shop/prefactor/epPrefactor";
import EPFinal from "./components/epPurchase/shop/final/epFinal";
import SPListPendingDocument from "./components/simcardPurchase/pending/list/spListPendingDocument";
import SPPendingDocument from "./components/simcardPurchase/pending/document/spPendingDocument";
import DAValid from "./components/deliveryArea/delivery/valid/daValid";
import DAKit from "./components/deliveryArea/delivery/kit/daKit";
import DADocument from "./components/deliveryArea/delivery/document/daDocument";
import DAFinal from "./components/deliveryArea/delivery/final/daFinal";
import CWINFOSeller from "./components/changeOwnership/change/information-seller/info-seller";
import CWProfile from "./components/changeOwnership/change/profile/cwProfile";

import CWPrefactor from "./components/changeOwnership/change/prefactor/cwPrefactor";
import CWFinal from "./components/changeOwnership/change/final/cwFinal";
import CWSwapDocument from "./components/changeOwnership/change/swapDocument/cwSwapDocument";
import CWDocument from "./components/changeOwnership/change/document/cwDocument";
import WalletList from "./components/wallet/wallet-list/walletList";
import WalletCash from "./components/wallet/cash-wallet/cash/cash";
import WalletFinal from "./components/wallet/cash-wallet/final/final";
import SPReportList from "./components/simcardPurchase/reports/report-list/sp-report";

import CWReport from "./components/changeOwnership/reports/report-list/cw-report";
import CSReport from "./components/changeSimCard/reports/report-list/cs-report";
import DCReport from "./components/dcPurchase/report/report-list/dc-report";
import EPReport from "./components/epPurchase/report/report-list/ep-report";
import CWListPendingDocument from "./components/changeOwnership/pending/list/cwListPendingDocument";
import CWPendingDocument from "./components/changeOwnership/pending/document/cwPendingDocument";
import CSListPendingDocument from "./components/changeSimCard/pending/list/csListPendingDocument";
import CSPendingDocument from "./components/changeSimCard/pending/document/csPendingDocument";
import DAPendingDocument from "./components/deliveryArea/pending/document/daPendingDocument";
import DAListPendingDocument from "./components/deliveryArea/pending/list/daListPendingDocument";
import Notification from "./components/notification/notification";
import { CheckToken, Roles, setToken } from "./tools/services";
import CartablePostList from "./components/postcartable/cartablePostList";
import DaPrefactor from "./components/deliveryArea/delivery/prefactor/daprefactor";
import Search360 from "./components/360/search/search";
import ResultSearch360 from "./components/360/list/List360";
import ValidPayBill from "./components/paybill/shop/valid/valid";
import PrefactorPayBill from "./components/paybill/shop/prefactor/prefactor";
import FinalPayBill from "./components/paybill/shop/final/final";
import SearchCorporate from "./components/corporate_subscriber_search/corporate/search/SearchCorporate";
import UpdateNetwork from "./components/corporate_subscriber_search/corporate/UpdateMobileNetwork/UpdateNetwork";
import ActionSubscriber from "./components/corporate_subscriber_search/corporate/ActionSubscriber/ActionSubscriber";
import CoKit from "./components/corporate_subscriber_search/corporate/CoSimSwap/kit/CoSimKit";
import CoSimKit from "./components/corporate_subscriber_search/corporate/CoSimSwap/kit/CoSimKit";
import CoSimPrefactor from "./components/corporate_subscriber_search/corporate/CoSimSwap/prefactor/CoSimPrefactor";
import CoSimFinal from "./components/corporate_subscriber_search/corporate/CoSimSwap/final/CoSimFinal";
import CowProfile from "./components/corporate_subscriber_search/corporate/CoChangeOwnerShip/Profile/CowProfile";
import CowUpload from "./components/corporate_subscriber_search/corporate/CoChangeOwnerShip/Upload/CowUpload";
import CowReview from "./components/corporate_subscriber_search/corporate/CoChangeOwnerShip/Review/CowReview";
import CowFinal from "./components/corporate_subscriber_search/corporate/CoChangeOwnerShip/Final/CowFinal";
import CDList from "./components/creditCards/list/cdList";
import CDEditProfile from "./components/creditCards/edit/CDEdit";
import CDReviewProfile from "./components/creditCards/reviewProfile/CDReviewProfile";
import CDUpload from "./components/creditCards/upload/CDUpload";
import CDCard from "./components/creditCards/card/CDCard";
import CDReviewRequest from "./components/creditCards/reviewRequest/CDReviewRequest";
import CDFinal from "./components/creditCards/final/CDFinal";
import { GoogleReCaptchaProvider } from "react-google-recaptcha-v3";
import { useAPIPublic } from "./tools/api";
import DCBulk from "./components/bulks/dc/DCBulk";

export const InitialAPP = () => {
	const { createApiTokenBySession } = useAPIPublic();
	useEffect(() => {
		const callApi = async () => {
			const isTokenValid = await CheckToken();
			if (!isTokenValid) {
				let param = {
					captcha: process.env.REACT_APP_CAPTCHA,
				};
				let responseToken = await createApiTokenBySession(param);
				if (responseToken) {
					await setToken(responseToken);
				}
			}
		};
		callApi();
	}, [createApiTokenBySession]);
};

export const ScrollToTop = () => {
	// Extracts pathname property(key) from an object
	const { pathname } = useLocation();

	// Automatically scrolls to top whenever pathname changes
	useEffect(() => {
		window.scrollTo(0, 0);
	}, [pathname]);
};
function App() {
	const {
		darkMode,
		// setDarkMode,
		rtlMode,
		// setRtlMode
	} = useTheme();

	// const toggleDarkMode = () => setDarkMode((prev) => !prev);
	// const toggleRtlMode = () => setRtlMode((prev) => !prev);
	useEffect(() => {
		// setDarkMode(window.matchMedia("(prefers-color-scheme: dark)").matches);
	}, []);

	return (
		<>
			{/* <InitialAPP /> */}
			{/* <GoogleReCaptchaProvider reCaptchaKey="6LftFPsfAAAAACQ1A9WLQrAMzzDGgSj0cxkosUK2"> */}
			<Router>
				<div className="App" data-dark={darkMode} data-dir={rtlMode}>
					<Header />
					<Provider store={store}>
						<PersistGate loading={null} persistor={persistor}>
							<Routes desc="login pages">
								{/*#region Login Pages Area */}
								<Route path={"/"} element={<ProtectedRouteLogin path={"/"} element={Login} />} />
								<Route path={_adr.Root} element={<ProtectedRouteLogin path={"/"} element={Login} />} />
								<Route path={_adr.Root + _adr.Login.Index} element={<ProtectedRouteLogin element={Login} />} />
								<Route path={_adr.Root + _adr.Login.ForgetPassword} element={<ProtectedRouteLogin element={ForgetPassword} />} />
								<Route path={_adr.Root + _adr.Login.OtpConfirm} element={<ProtectedRouteLogin element={TwoStepConfirm} />} />
								<Route path={_adr.Root + _adr.Login.ResetPassword} element={<ProtectedRouteLogin element={ChangePassword} />} />
								{/*#endregion Login Pages Area */}
							</Routes>
							<Routes desc="global pages">
								<Route
									element={
										<MainLayout>
											<Outlet />
										</MainLayout>
									}>
									<Route path={_adr.Root + _adr.Home} element={<ProtectedRoute role="global" element={Dashboard} />} />
									{/*#region SimCard Purchase */}
									<Route
										path={_adr.Root + _adr.SimCardPurchase.Index + _adr.SimCardPurchase.Kit}
										element={<ProtectedRoute role={Roles.Dealer_RegisterSim_B2C_Iranian} element={SPKit} />}
									/>
									<Route
										path={_adr.Root + _adr.SimCardPurchase.Index + _adr.SimCardPurchase.Msisdn}
										element={<ProtectedRoute role={Roles.Dealer_RegisterSim_B2C_Iranian} element={SPMsisdn} />}
									/>
									<Route
										path={_adr.Root + _adr.SimCardPurchase.Index + _adr.SimCardPurchase.Profile}
										element={<ProtectedRoute role={Roles.Dealer_RegisterSim_B2C_Iranian} element={SPProfile} />}
									/>
									<Route
										path={_adr.Root + _adr.SimCardPurchase.Index + _adr.SimCardPurchase.PreFactor}
										element={<ProtectedRoute role={Roles.Dealer_RegisterSim_B2C_Iranian} element={SpPreFactor} />}
									/>
									<Route
										path={_adr.Root + _adr.SimCardPurchase.Index + _adr.SimCardPurchase.Document}
										element={<ProtectedRoute role={Roles.Dealer_RegisterSim_B2C_Iranian} element={SPDocument} />}
									/>
									<Route
										path={_adr.Root + _adr.SimCardPurchase.Index + _adr.SimCardPurchase.Final}
										element={<ProtectedRoute role={Roles.Dealer_RegisterSim_B2C_Iranian} element={SPFinalFactor} />}
									/>
									{/* sim card foreigners */}
									<Route
										path={_adr.Root + _adr.SimCardPurchase.foreigners + _adr.SimCardPurchase.foreignersChild.Kit}
										element={<ProtectedRoute role={Roles.Dealer_RegisterSim_B2C_NonIranian} element={SPFKit} />}
									/>
									<Route
										path={_adr.Root + _adr.SimCardPurchase.foreigners + _adr.SimCardPurchase.foreignersChild.Msisdn}
										element={<ProtectedRoute role={Roles.Dealer_RegisterSim_B2C_NonIranian} element={SPFMsisdn} />}
									/>
									<Route
										path={_adr.Root + _adr.SimCardPurchase.foreigners + _adr.SimCardPurchase.foreignersChild.Authentication}
										element={<ProtectedRoute role={Roles.Dealer_RegisterSim_B2C_NonIranian} element={SPFAuthentication} />}
									/>
									<Route
										path={_adr.Root + _adr.SimCardPurchase.foreigners + _adr.SimCardPurchase.foreignersChild.Profile}
										element={<ProtectedRoute role={Roles.Dealer_RegisterSim_B2C_NonIranian} element={SPFProfile} />}
									/>
									<Route
										path={_adr.Root + _adr.SimCardPurchase.foreigners + _adr.SimCardPurchase.foreignersChild.PreFactor}
										element={<ProtectedRoute role={Roles.Dealer_RegisterSim_B2C_NonIranian} element={SPFPrefactor} />}
									/>
									<Route
										path={_adr.Root + _adr.SimCardPurchase.foreigners + _adr.SimCardPurchase.foreignersChild.Document}
										element={<ProtectedRoute role={Roles.Dealer_RegisterSim_B2C_NonIranian} element={SPFDocument} />}
									/>
									<Route
										path={_adr.Root + _adr.SimCardPurchase.foreigners + _adr.SimCardPurchase.foreignersChild.Final}
										element={<ProtectedRoute role={Roles.Dealer_RegisterSim_B2C_NonIranian} element={SPFFinalFactor} />}
									/>
									<Route
										path={_adr.Root + _adr.SimCardPurchase.Index + _adr.SimCardPurchase.Pending.Index + _adr.SimCardPurchase.Pending.List}
										element={<ProtectedRoute role={Roles.Dealer_RegisterSim_Report_UploadingDoc} element={SPListPendingDocument} />}
									/>
									<Route
										path={_adr.Root + _adr.SimCardPurchase.Index + _adr.SimCardPurchase.Pending.Index + _adr.SimCardPurchase.Pending.upload}
										element={<ProtectedRoute role={Roles.Dealer_RegisterSim_Report_UploadingDoc} element={SPPendingDocument} />}
									/>
									{/*#endregion SimCard Purchase */}
									{/*#region SimCard Report */}
									<Route
										path={_adr.Root + _adr.SimCardPurchase.Index + _adr.SimCardPurchase.Report.Index + _adr.SimCardPurchase.Report.List}
										element={<ProtectedRoute role={Roles.Dealer_RegisterSim_Report_One} element={SPReportList} />}
									/>
									{/*#endregion SimCard Report */}
									{/*#region #region Simcard Repacement */}
									<Route
										path={_adr.Root + _adr.SimCardReplacement.Index + _adr.SimCardReplacement.Replacement + _adr.SimCardReplacement.ValidMsisdn}
										element={<ProtectedRoute role={Roles.Dealer_SimSwap_B2C_Iranian} element={CSValidMsisdn} />}
									/>
									<Route
										path={_adr.Root + _adr.SimCardReplacement.Index + _adr.SimCardReplacement.Replacement + _adr.SimCardReplacement.ValidKit}
										element={<ProtectedRoute role={Roles.Dealer_SimSwap_B2C_Iranian} element={CSNewKit} />}
									/>
									<Route
										path={_adr.Root + _adr.SimCardReplacement.Index + _adr.SimCardReplacement.Replacement + _adr.SimCardReplacement.PreFactor}
										element={<ProtectedRoute role={Roles.Dealer_SimSwap_B2C_Iranian} element={CSPrefactor} />}
									/>
									<Route
										path={_adr.Root + _adr.SimCardReplacement.Index + _adr.SimCardReplacement.Replacement + _adr.SimCardReplacement.Document}
										element={<ProtectedRoute role={Roles.Dealer_SimSwap_B2C_Iranian} element={CSDocument} />}
									/>
									<Route
										path={_adr.Root + _adr.SimCardReplacement.Index + _adr.SimCardReplacement.Replacement + _adr.SimCardReplacement.Final}
										element={<ProtectedRoute role={Roles.Dealer_SimSwap_B2C_Iranian} element={CSFinalFactor} />}
									/>
									{/* #region Simcard Repacement */}

									{/* report of change simcard */}
									<Route
										path={_adr.Root + _adr.SimCardReplacement.Index + _adr.SimCardReplacement.Report.Index + _adr.SimCardReplacement.Report.List}
										element={<ProtectedRoute role={Roles.Dealer_SimSwap_Report_One} element={CSReport} />}
									/>
									{/* report of change simcard */}
									{/* pending upload document change simcard */}
									<Route
										path={_adr.Root + _adr.SimCardReplacement.Index + _adr.SimCardReplacement.Pending.Index + _adr.SimCardReplacement.Pending.List}
										element={<ProtectedRoute role={Roles.Dealer_SimSwap_Report_UploadingDoc} element={CSListPendingDocument} />}
									/>
									<Route
										path={_adr.Root + _adr.SimCardReplacement.Index + _adr.SimCardReplacement.Pending.Index + _adr.SimCardReplacement.Pending.upload}
										element={<ProtectedRoute role={Roles.Dealer_SimSwap_Report_UploadingDoc} element={CSPendingDocument} />}
									/>
									{/* pending upload document change simcard */}
									{/* Delivery Area */}
									<Route
										path={_adr.Root + _adr.DeliveryArea.Index + _adr.DeliveryArea.Delivery.Index + _adr.DeliveryArea.Delivery.Valid}
										element={<ProtectedRoute role={Roles.Dealer_SimSwap_B2C_Iranian_DeliveryAreas} element={DAValid} />}
									/>
									<Route
										path={_adr.Root + _adr.DeliveryArea.Index + _adr.DeliveryArea.Delivery.Index + _adr.DeliveryArea.Delivery.Kit}
										element={<ProtectedRoute role={Roles.Dealer_SimSwap_B2C_Iranian_DeliveryAreas} element={DAKit} />}
									/>
									<Route
										path={_adr.Root + _adr.DeliveryArea.Index + _adr.DeliveryArea.Delivery.Index + _adr.DeliveryArea.Delivery.Prefactor}
										element={<ProtectedRoute role={Roles.Dealer_SimSwap_Can_PickupMethodOfReceipt} element={DaPrefactor} />}
									/>
									<Route
										path={_adr.Root + _adr.DeliveryArea.Index + _adr.DeliveryArea.Delivery.Index + _adr.DeliveryArea.Delivery.Document}
										element={<ProtectedRoute role={Roles.Dealer_SimSwap_B2C_Iranian_DeliveryAreas} element={DADocument} />}
									/>
									<Route
										path={_adr.Root + _adr.DeliveryArea.Index + _adr.DeliveryArea.Delivery.Index + _adr.DeliveryArea.Delivery.Final}
										element={<ProtectedRoute role={Roles.Dealer_SimSwap_B2C_Iranian_DeliveryAreas} element={DAFinal} />}
									/>
									{/* Delivery Area */}
									{/* pending upload document Delivery Area */}
									<Route
										path={_adr.Root + _adr.DeliveryArea.Index + _adr.DeliveryArea.Pending.Index + _adr.DeliveryArea.Pending.List}
										element={<ProtectedRoute role={Roles.Dealer_SimSwap_B2C_Iranian_DeliveryAreas_UploadingDoc} element={DAListPendingDocument} />}
									/>
									<Route
										path={_adr.Root + _adr.DeliveryArea.Index + _adr.DeliveryArea.Pending.Index + _adr.DeliveryArea.Pending.upload}
										element={<ProtectedRoute role={Roles.Dealer_SimSwap_B2C_Iranian_DeliveryAreas_UploadingDoc} element={DAPendingDocument} />}
									/>
									{/* pending upload document Delivery Area*/}
									{/* Change OwnerShip */}
									<Route
										path={
											_adr.Root + _adr.ChangeOwnerShip.Index + _adr.ChangeOwnerShip.OwnerShip.Index + _adr.ChangeOwnerShip.OwnerShip.InformationSeller
										}
										element={<ProtectedRoute role={Roles.Dealer_ChangeOwner_B2C_Iranian} element={CWINFOSeller} />}
									/>
									<Route
										path={_adr.Root + _adr.ChangeOwnerShip.Index + _adr.ChangeOwnerShip.OwnerShip.Index + _adr.ChangeOwnerShip.OwnerShip.Profile}
										element={<ProtectedRoute role={Roles.Dealer_ChangeOwner_B2C_Iranian} element={CWProfile} />}
									/>
									<Route
										path={_adr.Root + _adr.ChangeOwnerShip.Index + _adr.ChangeOwnerShip.OwnerShip.Index + _adr.ChangeOwnerShip.OwnerShip.SwapDocument}
										element={<ProtectedRoute role={Roles.Dealer_ChangeOwner_B2C_Iranian} element={CWSwapDocument} />}
									/>
									<Route
										path={_adr.Root + _adr.ChangeOwnerShip.Index + _adr.ChangeOwnerShip.OwnerShip.Index + _adr.ChangeOwnerShip.OwnerShip.Prefactor}
										element={<ProtectedRoute role={Roles.Dealer_ChangeOwner_B2C_Iranian} element={CWPrefactor} />}
									/>
									<Route
										path={_adr.Root + _adr.ChangeOwnerShip.Index + _adr.ChangeOwnerShip.OwnerShip.Index + _adr.ChangeOwnerShip.OwnerShip.Document}
										element={<ProtectedRoute role={Roles.Dealer_ChangeOwner_B2C_Iranian} element={CWDocument} />}
									/>
									<Route
										path={_adr.Root + _adr.ChangeOwnerShip.Index + _adr.ChangeOwnerShip.OwnerShip.Index + _adr.ChangeOwnerShip.OwnerShip.Final}
										element={<ProtectedRoute role={Roles.Dealer_ChangeOwner_B2C_Iranian} element={CWFinal} />}
									/>
									{/* Change OwnerShip */}
									{/* list change ownership */}
									<Route
										path={_adr.Root + _adr.ChangeOwnerShip.Index + _adr.ChangeOwnerShip.Report.Index + _adr.ChangeOwnerShip.Report.List}
										element={<ProtectedRoute role={Roles.Dealer_ChangeOwner_Report_One} element={CWReport} />}
									/>
									{/* list change ownership */}
									{/* pending upload document change ownership */}
									<Route
										path={_adr.Root + _adr.ChangeOwnerShip.Index + _adr.ChangeOwnerShip.Pending.Index + _adr.ChangeOwnerShip.Pending.List}
										element={<ProtectedRoute role={Roles.Dealer_ChangeOwner_Report_UploadingDoc} element={CWListPendingDocument} />}
									/>
									<Route
										path={_adr.Root + _adr.ChangeOwnerShip.Index + _adr.ChangeOwnerShip.Pending.Index + _adr.ChangeOwnerShip.Pending.upload}
										element={<ProtectedRoute role={Roles.Dealer_ChangeOwner_Report_UploadingDoc} element={CWPendingDocument} />}
									/>
									{/* pending upload document change ownership */}
									{/* wallet  */}
									<Route
										path={_adr.Root + _adr.Wallet.Index + _adr.Wallet.WalletList}
										element={<ProtectedRoute role={Roles.Dealer_Wallet_Management} element={WalletList} />}
									/>
									<Route
										path={_adr.Root + _adr.Wallet.Index + _adr.Wallet.Withdraw.Index + _adr.Wallet.Withdraw.Change}
										element={<ProtectedRoute role={Roles.Dealer_Wallet_Management} element={WalletCash} />}
									/>
									<Route
										path={_adr.Root + _adr.Wallet.Index + _adr.Wallet.Withdraw.Index + _adr.Wallet.Withdraw.Final}
										element={<ProtectedRoute role={Roles.Dealer_Wallet_Management} element={WalletFinal} />}
									/>
									{/* wallet  */}
									{/* profile account */}
									<Route
										path={_adr.Root + _adr.Accounts.Index + _adr.Accounts.ViewProfile}
										element={<ProtectedRoute role={Roles.Global} element={ViewProfile} />}
									/>
									<Route
										path={_adr.Root + _adr.Accounts.Index + _adr.Accounts.ChangePassword}
										element={<ProtectedRoute role={Roles.Global} element={Changepassword} />}
									/>
									<Route
										path={_adr.Root + _adr.Accounts.Index + _adr.Accounts.AccountInfo}
										element={<ProtectedRoute role={Roles.Global} element={AccountInfo} />}
									/>
									<Route
										path={_adr.Root + _adr.Accounts.Index + _adr.Accounts.AccountList}
										element={<ProtectedRoute role={Roles.Global} element={Accountlist} />}
									/>
									<Route path={_adr.Root + _adr.Notification.Index} element={<ProtectedRoute role={Roles.Global} element={Notification} />} />
									{/* profile account */}
									{/* direction charge  */}
									<Route
										path={_adr.Root + _adr.DCPurchase.Index + _adr.DCPurchase.Shop + _adr.DCPurchase.Charge}
										element={<ProtectedRoute role={Roles.Dealer_DCPurchase_B2C} element={DCCharge} />}
									/>
									<Route
										path={_adr.Root + _adr.DCPurchase.Index + _adr.DCPurchase.Shop + _adr.DCPurchase.Prefactor}
										element={<ProtectedRoute role={Roles.Dealer_DCPurchase_B2C} element={DCPrefactor} />}
									/>
									<Route
										path={_adr.Root + _adr.DCPurchase.Index + _adr.DCPurchase.Shop + _adr.DCPurchase.Final}
										element={<ProtectedRoute role={Roles.Dealer_DCPurchase_B2C} element={DCFinal} />}
									/>
									<Route
										path={_adr.Root + _adr.DCPurchase.Index + _adr.DCPurchase.Report.Index + _adr.DCPurchase.Report.List}
										element={<ProtectedRoute role={Roles.Dealer_DCPurchase_ReportOne} element={DCReport} />}
									/>
									{/* direction charge */}

									{/* direction charge  */}
									<Route
										path={_adr.Root + _adr.PayBill.Index + _adr.PayBill.Shop + _adr.PayBill.Bill}
										element={<ProtectedRoute role={Roles.Dealer_HotBill_Pay} element={ValidPayBill} />}
									/>
									<Route
										path={_adr.Root + _adr.PayBill.Index + _adr.PayBill.Shop + _adr.PayBill.Prefactor}
										element={<ProtectedRoute role={Roles.Dealer_HotBill_Pay} element={PrefactorPayBill} />}
									/>
									<Route
										path={_adr.Root + _adr.PayBill.Index + _adr.PayBill.Shop + _adr.PayBill.Final}
										element={<ProtectedRoute role={Roles.Dealer_HotBill_Pay} element={FinalPayBill} />}
									/>
									{/* <Route
										path={_adr.Root + _adr.DCPurchase.Index + _adr.DCPurchase.Report.Index + _adr.DCPurchase.Report.List}
										element={<ProtectedRoute role={Roles.Dealer_DCPurchase_ReportOne} element={DCReport} />}
									/> */}
									{/* direction charge */}

									{/* extra packages */}
									<Route
										path={_adr.Root + _adr.EPPurchase.Index + _adr.EPPurchase.Shop + _adr.EPPurchase.Valid}
										element={<ProtectedRoute role={Roles.Dealer_EPPurchase_B2C} element={EPValid} />}
									/>
									<Route
										path={_adr.Root + _adr.EPPurchase.Index + _adr.EPPurchase.Shop + _adr.EPPurchase.PreFactor}
										element={<ProtectedRoute role={Roles.Dealer_EPPurchase_B2C} element={EPPrefactor} />}
									/>
									<Route
										path={_adr.Root + _adr.EPPurchase.Index + _adr.EPPurchase.Shop + _adr.EPPurchase.Final}
										element={<ProtectedRoute role={Roles.Dealer_EPPurchase_B2C} element={EPFinal} />}
									/>
									<Route
										path={_adr.Root + _adr.EPPurchase.Index + _adr.EPPurchase.Report.Index + _adr.EPPurchase.Report.List}
										element={<ProtectedRoute role={Roles.Dealer_EPPurchase_ReportOne} element={EPReport} />}
									/>
									{/* extra packages */}

									{/* cartable post */}
									<Route
										path={_adr.Root + _adr.CartablePost.Index}
										element={<ProtectedRoute role={Roles.CRM_RegisterSim_Catable_Post} element={CartablePostList} />}
									/>

									{/* Service 360 */}
									<Route
										path={_adr.Root + _adr.Services360.Index}
										element={<ProtectedRoute role={Roles.Delear_360_Customerservice} element={Search360} />}
									/>
									<Route
										path={_adr.Root + _adr.Services360.Index + _adr.Services360.List}
										element={<ProtectedRoute role={Roles.Delear_360_Customerservice} element={ResultSearch360} />}
									/>
									{/* Service 360 */}

									{/* corporate Subscriber Search */}
									<Route
										path={_adr.Root + _adr.Corporate.Index + _adr.Corporate.Search}
										element={<ProtectedRoute role={Roles.Dealer_SearchB2B_Subscription} element={SearchCorporate} />}
									/>
									<Route
										path={_adr.Root + _adr.Corporate.Index + _adr.Corporate.UpdateNetwork}
										element={<ProtectedRoute role={Roles.Dealer_UpdateMobile_Network} element={UpdateNetwork} />}
									/>
									<Route
										path={_adr.Root + _adr.Corporate.Index + _adr.Corporate.Action}
										element={<ProtectedRoute role={Roles.Dealer_SearchB2B_Subscription} element={ActionSubscriber} />}
									/>

									{/* Sim Swap */}

									<Route
										path={_adr.Root + _adr.Corporate.Index + _adr.Corporate.SimSwap.Index + _adr.Corporate.SimSwap.ValidKit}
										element={<ProtectedRoute role={Roles.Dealer_SearchB2B_Subscription} element={CoSimKit} />}
									/>
									<Route
										path={_adr.Root + _adr.Corporate.Index + _adr.Corporate.SimSwap.Index + _adr.Corporate.SimSwap.PreFactor}
										element={<ProtectedRoute role={Roles.Dealer_SearchB2B_Subscription} element={CoSimPrefactor} />}
									/>
									<Route
										path={_adr.Root + _adr.Corporate.Index + _adr.Corporate.SimSwap.Index + _adr.Corporate.SimSwap.Final}
										element={<ProtectedRoute role={Roles.Dealer_SearchB2B_Subscription} element={CoSimFinal} />}
									/>

									{/* Sim Swap */}

									{/* Change OwnerShip */}

									<Route
										path={_adr.Root + _adr.Corporate.Index + _adr.Corporate.Ownership.Index + _adr.Corporate.Ownership.Profile}
										element={<ProtectedRoute role={Roles.Dealer_SearchB2B_Subscription} element={CowProfile} />}
									/>
									<Route
										path={_adr.Root + _adr.Corporate.Index + _adr.Corporate.Ownership.Index + _adr.Corporate.Ownership.Upload}
										element={<ProtectedRoute role={Roles.Dealer_SearchB2B_Subscription} element={CowUpload} />}
									/>
									<Route
										path={_adr.Root + _adr.Corporate.Index + _adr.Corporate.Ownership.Index + _adr.Corporate.Ownership.Review}
										element={<ProtectedRoute role={Roles.Dealer_SearchB2B_Subscription} element={CowReview} />}
									/>
									<Route
										path={_adr.Root + _adr.Corporate.Index + _adr.Corporate.Ownership.Index + _adr.Corporate.Ownership.Final}
										element={<ProtectedRoute role={Roles.Dealer_SearchB2B_Subscription} element={CowFinal} />}
									/>

									{/* Change OwnerShip */}

									{/* Corporate Subscriber Search */}

									{/* credit Card */}

									<Route
										path={_adr.Root + _adr.CreditCard.Index + _adr.CreditCard.List}
										element={<ProtectedRoute role={Roles.Dealer_SearchB2B_Subscription} element={CDList} />}
									/>
									<Route
										path={_adr.Root + _adr.CreditCard.Index + _adr.CreditCard.Edit}
										element={<ProtectedRoute role={Roles.Dealer_SearchB2B_Subscription} element={CDEditProfile} />}
									/>
									<Route
										path={_adr.Root + _adr.CreditCard.Index + _adr.CreditCard.Profile}
										element={<ProtectedRoute role={Roles.Dealer_SearchB2B_Subscription} element={CDReviewProfile} />}
									/>
									<Route
										path={_adr.Root + _adr.CreditCard.Index + _adr.CreditCard.Document}
										element={<ProtectedRoute role={Roles.Dealer_SearchB2B_Subscription} element={CDUpload} />}
									/>
									<Route
										path={_adr.Root + _adr.CreditCard.Index + _adr.CreditCard.Card}
										element={<ProtectedRoute role={Roles.Dealer_SearchB2B_Subscription} element={CDCard} />}
									/>
									<Route
										path={_adr.Root + _adr.CreditCard.Index + _adr.CreditCard.Review}
										element={<ProtectedRoute role={Roles.Dealer_SearchB2B_Subscription} element={CDReviewRequest} />}
									/>
									<Route
										path={_adr.Root + _adr.CreditCard.Index + _adr.CreditCard.Final}
										element={<ProtectedRoute role={Roles.Dealer_SearchB2B_Subscription} element={CDFinal} />}
									/>
									{/* credit Card */}

									{/* Bulks */}
									<Route
										path={_adr.Root + _adr.Bulks.Index + _adr.Bulks.DCBulk}
										element={<ProtectedRoute role={Roles.Dealer_GroupActivation_API} element={DCBulk} />}
									/>
									{/* Bulks */}
								</Route>
							</Routes>
						</PersistGate>
					</Provider>
				</div>
				<ScrollToTop />
			</Router>
			<ToastContainer />
			{/* </GoogleReCaptchaProvider> */}
		</>
	);
}

export default App;
